import Marionette from "backbone.marionette";
import Moment from "moment";

import MainViewTpl from "./mainView.ejs";

import CSSFONTS from "../../application/fonts.css";

// Admin LTE
import CSSA from "../../application/adminlte/bower_components/font-awesome/css/font-awesome.min.css";
import CSSI from "../../application/adminlte/bower_components/Ionicons/css/ionicons.min.css";
import CSSLTE from "../../application/adminlte/dist/css/AdminLTE.min.css";
import CSSSKIN from "../../application/adminlte/dist/css/skins/_all-skins.min.css";
import CSSiCHECK from "../../application/adminlte/plugins/iCheck/all.css";

require("../../application/adminlte/dist/js/adminlte.js");

// Custom CSS
import CSS from "./main.css";

// Views
import NavbarView from "views/navbar/navbarView.js";
import DashboardView from "views/dashboard/dashboardView.js";
import ProfileView from "views/profile/profileView.js";
import PasswdView from "views/password/passwordView.js";
import InstancesView from "views/instances/instancesView.js";
import InstancesSelectView from "views/instances_s/instancesView.js";
import UsersView from "views/users/usersView.js";
import CompaniesView from "views/companies/companiesView.js";
import PermissionsView from "views/permissions/permissionsView.js";
import SectionsView from "views/sections/sectionsView.js";
import ListsView from "views/lists/listsView.js";
import GoodsDetail from "views/goodsDetail/goodsDetailView.js";
import GoodsPDF from "views/goodsPDF/goodsPDFView.js";
import ReportView from "views/report/reportView.js";
import MastersView from "views/masters/mastersView.js";
import LogsView from "views/logs/logsView.js";
import ImportView from "views/import/importView.js";
import MenuView from 'views/menu/menuView.js';

import PlanosView from "views/planos/planos.js";

import ParametersView from "views/parameters/parametersView.js";

///////FAQ 
import FaqView from "views/faq/faqView.js";

// Collections
import UsersCollection from "collections/usersCollection.js";
var usersCollection = new UsersCollection();

import CompaniesCollection from "collections/companiesCollection.js";
var companiesCollection = new CompaniesCollection();

import InstancesCollection from "collections/instancesCollection.js";
var instancesCollection = new InstancesCollection();

import ListsCollection from "collections/listsCollection.js";
var listsCollection = new ListsCollection();

import GoodModel from "models/goodModel.js";
var goodModel = new GoodModel();

import MastersCollection from "collections/mastersCollection.js";
var mastersCollection = new MastersCollection();

import ReportCollection from "collections/reportCollection.js";
var reportCollection = new ReportCollection();

import ParametersModel from "models/parametersModel.js";
var parametersModel = new ParametersModel();

import LogsCollection from "collections/logsCollection.js";
var logsCollection = new LogsCollection();

import OptionsModel from "models/optionsModel.js";
var optionsModel = new OptionsModel();

import S from "session/session.js";
import T from "session/token.js";

require('bootstrap-confirmation');
require('jquery-mask-plugin');


var initView;
export default Marionette
    .LayoutView
    .extend({
        initialize: function() {

            this.listenTo(S.mApp, "modal", function(content) {
                this.modalRegion.show(content.view);
            }.bind(this));
            this.listenTo(S.mApp, "navigate", this.navigate.bind(this));
            this.listenTo(S.mApp, "recalculateAreas", this.recalculateAreas); //Used for limiting areas list according to your instance permissions          
        },
        template: MainViewTpl,
        render: function() {

            $("body").addClass("hold-transition skin-black fixed sidebar-mini");

            initView = this;

            this.$el.html(this.template);

            this.navbarRegion.show(new NavbarView());

            if (window.top.location.hash !== "#" && window.top.location.hash !== "")
                window.top.location = "#";

            // Routing Functions /////////////////////////////////////////
            //
            var RouterController = Marionette.Controller.extend({
                home: function() {
                    initView.dataRegion.show(new DashboardView());
                },
                companies: function() {
                    initView.dataRegion.show(new CompaniesView({ collection: companiesCollection }));
                },
                menu: function(parent) {


                    initView.dataRegion.show(new MenuView({
                        model: optionsModel,
                        parent: parent || 0
                    }));
                },
                users: function() {
                    initView.dataRegion.show(new UsersView({ collection: usersCollection }));
                },
                enviros: function() {
                    initView.dataRegion.show(new InstancesView({ collection: instancesCollection }));
                },
                envirosSelect: function() {
                    initView.dataRegion.show(new InstancesSelectView({ collection: instancesCollection }));
                },
                lists: function() {
                    initView.dataRegion.show(new ListsView({ collection: listsCollection }));
                },
                epigraph: function(id) {
                    initView.dataRegion.show(new ListsView({
                        collection: listsCollection,
                        areaId: "epigraph_" + id
                    }));
                },
                funcional: function(id) {
                    initView.dataRegion.show(new ListsView({
                        collection: listsCollection,
                        areaId: "option_" + id
                    }));
                },
                search: function(id) {
                    initView.dataRegion.show(new ListsView({ collection: listsCollection, areaId: id }));
                },
                planos: function(id) {


                    //initView.dataRegion.show(new PlanosView());

                    initView.dataRegion.show(new PlanosView({
                        idPlano: id,
                        model: optionsModel,
                        parent: parent || 0
                    }));
                },

                detail_goo: function(id) {


                    S.userInfo.set({ options: S.mainMenu });

                    this.navbarRegion.show(new NavbarView());

                    initView.dataRegion.show(new GoodsDetail({
                        id: 1,
                        lang: null,
                        view: 0,
                        editable_i: 1
                    }));


                },

                profile: function() {
                    initView.dataRegion.show(new ProfileView());
                },
                password: function() {
                    initView.dataRegion.show(new PasswdView());
                },
                parameters: function() {
                    initView.dataRegion.show(new ParametersView({ model: parametersModel }));
                },
                logs: function() {
                    initView.dataRegion.show(new LogsView({ collection: logsCollection }));
                },
                import: function() {
                    initView.dataRegion.show(new ImportView());
                },
                mejoras: function() {
                    initView.dataRegion.show(new MastersView({ table: "mejoras", collection: mastersCollection }));
                },
                registrales: function() {
                    initView.dataRegion.show(new MastersView({ table: "registrales", collection: mastersCollection }));
                },
                catastrales: function() {
                    initView.dataRegion.show(new MastersView({ table: "catastrales", collection: mastersCollection }));
                },
                titulos: function() {
                    initView.dataRegion.show(new MastersView({ table: "titulos", collection: mastersCollection }));
                },
                acuerdos: function() {
                    initView.dataRegion.show(new MastersView({ table: "acuerdos", collection: mastersCollection }));
                },
                bajas: function() {
                    initView.dataRegion.show(new ListsView({ collection: listsCollection, areaId: "bajas" }));
                },
                reports: function(type) {
                    initView.dataRegion.show(new ReportView({
                        table: "report_" + type,
                        collection: reportCollection
                    }));

                },
                faqview: function() {

                    initView.dataRegion.show(new FaqView({}));
                },

            });

            var myController = new RouterController();

            var myRouter = new Marionette.AppRouter({
                controller: myController,
                appRoutes: {
                    '': "home",
                    "home": "home",
                    // NAVIGATION FOLDERS
                    "menu": "menu",
                    "menu/:parent": "menu",
                    "area/:id": "menu",
                    "afunc/:id": "menu",
                    //"planos": "planos",
                    "planos:/id": "planos",
                    // USER MENU
                    "profile": "profile",
                    "password": "password",
                    // MAIN MENU
                    "companies": "companies",
                    "users": "users",
                    "enviro": "enviros",
                    // COMMON MENU
                    "bienes/:id": "lists",
                    "bajas/:id": "bajas",
                    "mejoras/:id": "mejoras",
                    "search/:id": "search",
                    "epigraph/:id": "epigraph",
                    "option/:id": "funcional",
                    "report/:type": "reports",
                    "registrales": "registrales",
                    "catastrales": "catastrales",
                    "acuerdos": "acuerdos",
                    "titulos": "titulos",
                    "parameters": "parameters",
                    "logs": "logs",
                    "import": "import",
                    // "planos": "planos",
                    "planos/:id": "planos",
                    "detail_g/:id": "detail_goo",
                    /////FAQ
                    "faq": "faqview",
                }
            });

            Backbone.history.start();
        },
        navigate: function(data) {


            switch (data.to) {
                case "permissions":
                    this.dataRegion.show(new PermissionsView({ model: data.model, collection: data.collection }));
                    window.top.location = "#permissions";
                    break;

                    ////para las sections ..
                case "sectioins_v":
                    this.dataRegion.show(new SectionsView({ model: data.model, collection: data.collection }));
                    window.top.location = "#sectioins_v";
                    break;

                case "goodDetail":

                    this.dataRegion.show(new GoodsDetail({
                        id: parseInt(data.good_id),
                        lang: data.lang,
                        view: data.view,
                        editable_i: data.isEditable
                    }));
                    window.top.location = "#assets";
                    break;

                    ///// LLAMADAS DESDE EL MAPA DE GIS
                case "detail_g":
                    this.dataRegion.show(new GoodsDetail({
                        id: parseInt(data.good_id),
                        lang: data.lang,
                        view: data.view,
                        editable_i: data.isEditable
                    }));
                    window.top.location = "#assets";
                    break;
                case "pdf_infop":
                    this.dataRegion.show(new GoodsDetail({
                        id: parseInt(data.good_id),
                        lang: data.lang,
                        view: data.view,
                        editable_i: data.isEditable
                    }));
                    window.top.location = "#assets";
                    break;

                case "pdfView":

                    $("#loaderContainer").show();
                    var formsData = [];
                    var region = this.hiddenRegion;
                    if (!region.el)
                        region.el = "#hiddenRegion";

                    var j = data.goods.length - 1;


                    // Load templates recursively
                    function loadTemplatex() {

                        ////Solo si j == -1, se mete aqui en este apartado. 
                        if (j === -1) {

                            var xhr = new XMLHttpRequest();
                            xhr.open('POST', 'api/pdf/goodDetail.php', true);
                            xhr.setRequestHeader("Content-Type", "application/json");
                            xhr.setRequestHeader('Authorization', 'Bearer ' + S.token);
                            xhr.responseType = 'arraybuffer';
                            xhr.onload = function(e) {
                                if (this.status == 200) {

                                    var blob = new Blob([this.response], { type: "application/pdf" });
                                    var link = document.createElement('a');
                                    link.href = window.URL.createObjectURL(blob);
                                    //console.log(data);
                                    //link.download = "report_" + Moment().format('DD-MM-YYYY') + ".pdf";

                                    if (data.goods.length == 1) {

                                        link.download = "id_" + data.goods[0] + "_" + Moment().format('DD-MM-YYYY') + ".pdf";
                                    } else
                                        link.download = "list_" + Moment().format('DD-MM-YYYY_h-mm-ss') + ".pdf";
                                    link.click();
                                }
                                $("#loaderContainer").hide();
                                region.reset();
                            };

                            formsData.secretario = data.secretario;


                            xhr.send(JSON.stringify({ data: formsData, secretario: data.secretario, instanceId: '' }));
                            return;
                        } else {


                            region.show(new GoodsPDF({
                                id: parseInt(data.goods[j]),
                                lang: data.lang,
                                isEditableGood: data.viewable
                            }));
                            j--;
                        }
                    }


                    ///la primera vez no se llama, se llame a GodsPDF, entra aqui. 
                    S.mApp.off("end:pdf").on("end:pdf", function(formData) {
                        /////formData, son cada una de las secciones esto lo trata y lo envia el goodsPDFView.js

                        /////Va añadiendo en el array de bienes todas las secctions de los bienes consultados 1 o n .
                        formsData.push(formData);
                        loadTemplatex();
                    });

                    ///Llama a la funcion. 
                    loadTemplatex();
                    break;
                case "lists":
                    this.dataRegion.show(new ListsView({ collection: listsCollection }));
                    break;
                case "bajas":
                    this.dataRegion.show(new ListsView({ collection: listsCollection, areaId: "bajas" }));
                    break;
                case "masters":
                    this.dataRegion.show(new MastersView({ table: data.table, collection: mastersCollection }));
                    break;
                case "reports":
                    this.dataRegion.show(new ReportView({ table: data.table, collection: reportCollection }));
                    break;
                case "areas":
                    this.dataRegion.show(new ListsView({ collection: listsCollection }));
                    break;
            }
        },
        recalculateAreas: function() {


            S.areas = {};
            // Create list of functional areas for later use
            _.each(S.userInfo.attributes.options, function(option) {
                if (option.parent === "0") {
                    if (_.size(option.children)) {
                        for (var i in option.children) {
                            var childOption = option.children[i];
                            for (var j in childOption.children) {
                                var subOption = childOption.children[j];
                                var subText = S.userInfo.attributes.lang[subOption.item];
                                var data = {};
                                S.areas[subOption.item] = subText;
                            }
                        }
                    }
                }
            });
        },
        regions: {
            navbarRegion: "#wrapper",
            dataRegion: "#page-wrapper",
            modalRegion: "#insertModal",
            hiddenRegion: "#hiddenRegion"
        }
    });


//////////////////
// WEBPACK FOOTER
// ./app/views/mainView.js
// module id = 193
// module chunks = 0